import { render, staticRenderFns } from "./ChangePasswordEmail.vue?vue&type=template&id=9bdc3824&"
import script from "./ChangePasswordEmail.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports